import React, { useCallback, useMemo, useState } from 'react';
import VibeScreen from './components/vibe-screen';
import { SohoVibeContext } from './context';

const SohoVibeFlowWrapper = ({
  children,
  enabled = true,
  onComplete = null,
  renderReviewScreen = null
}) => {
  const [flowCompleted, setFlowCompleted] = useState(() => !enabled);
  const [isReviewRequested, setIsReviewRequested] = useState(false);

  const completeFlow = useCallback(
    ({ toReview = false } = {}) => {
      if (onComplete) onComplete();
      setIsReviewRequested(toReview && Boolean(renderReviewScreen));
      setFlowCompleted(true);
    },
    [onComplete, renderReviewScreen]
  );

  const exitReviewScreen = useCallback(() => setIsReviewRequested(false), []);

  const contextValue = useMemo(
    () => ({ isReviewRequested }),
    [isReviewRequested]
  );

  if (flowCompleted) {
    if (isReviewRequested && renderReviewScreen) {
      return renderReviewScreen(exitReviewScreen);
    }

    return (
      <SohoVibeContext.Provider value={contextValue}>
        {children}
      </SohoVibeContext.Provider>
    );
  }

  return <VibeScreen onComplete={completeFlow} />;
};

export default SohoVibeFlowWrapper;
